var template = require('./template.hbs');
var thumbnailTemplate = require('./template-thumbnail.hbs');
var ScrollableMixin = require('../../../components/mixins/scrollable');
var FormatFactory = require('../../../../../factory/formats');
var DesignFacade = require('../../../../../facade/design/design');
var EditorModeManager = require('../../../../editor-mode-manager');

module.exports = Backbone.mixin(Backbone.View.extend({
  mismatchPerfect: 20,
  mismatchSame: 50,
  events: {
    'click button.load': 'loadEvent',
    'click button.generate': 'generateEvent',
    'click li.thumbnail': 'migrateEvent'
  },

  loadEvent: function () {
    var fromFormatId = this.$el.find('select.from-format').val();
    var toFormatId = this.$el.find('select.to-format').val();

    this.$el.find('.load-process').addClass('hidden');
    this.$el.find('.progress').removeClass('hidden');
    INKIVE.Modal.loader(this.$el.find('.progress'));

    $.when(
      this.loadAllTemplatesByFormat(fromFormatId, 1),
      this.loadAllTemplatesByFormat(toFormatId, 0)
    )
    .then(this.preloadThumbnails).then(this.compare).then(this.renderThumbnails)
    .then(_.bind(function () {
      INKIVE.Modal.loaderClose(this.$el.find('.progress'));
      this.$el.find('button.generate').removeClass('hidden');
      this.$el.find('.progress').addClass('hidden');
    }, this));

    $.when(
      FormatFactory.getFormat(fromFormatId),
      FormatFactory.getFormat(toFormatId)
    ).then(_.bind(function (fromFormat, toFormat) {
      this.fromFormat = fromFormat;
      this.toFormat = toFormat;
    }, this));
  },

  generateEvent: function () {
    var processTemplate = _.bind(processTemplate, this);
    var templates = _.filter(this.templates, function (template) {
      return !template.match;
    });
    var total = templates.length;

    processTemplate();

    function processTemplate () {
      INKIVE.Modal.togglePageLoader(false);

      if (templates.length) {
        try { this.generateMatch(templates.pop()).then(processTemplate); } catch (err) { processTemplate(); }
        INKIVE.Modal.togglePageLoader(true, 'Generating matching template ' + (total - templates.length) + ' of ' + total);
      }
    }
  },

  migrateEvent: function (event) {
    var $item = $(event.currentTarget);
    var template = _.findWhere(this.templates, { id: $item.data('templateid') });

    template.match || this.generateMatch(template);
    if (template.match) {
      var modal = INKIVE.Modal.modalWindow('Edit copy or create a new one?', {
        headerIcon: 'icon-info',
        headerTitle: 'Migrate template',
        buttons: [{
          title: 'Edit current',
          onClick: _.bind(function () {
            this.editMatch(template.match);
            modal.close();
          }, this)
        }, {
          title: 'Create new',
          onClick: _.bind(function () {
            this.generateMatch(template);
            modal.close();
          }, this)
        }]
      });
    }
  },

  editMatch: function (template) {
    INKIVE.Helpers.api('search/layout', 'GET', { id: template['id'] }, _.bind(function (result) {
      EditorModeManager.setMode('template', result);
    }, this));
  },

  generateMatch: function (template) {
    return getOriginalTemplateData.call(this)
      .then(_.bind(createAsDifferentFormat, this))
      .then(_.bind(resizeContent, this))
      .then(_.bind(save, this))
      .then(this.updateThumbnail);

    function getOriginalTemplateData () {
      var deferred = $.Deferred();

      INKIVE.Helpers.api('search/layout', 'GET', { id: template['id'] }, function (result) {
        deferred.resolve(result);
      });

      return deferred.promise();
    }

    function createAsDifferentFormat (data) {
      var deferred = $.Deferred();
      var convertToPixels = INKIVE.Helpers.convertUnitsToPixels;

      var info = {
        'name': data['name'],
        'orientation': data['orientation'],
        'text': data['text'],
        'isBackground': data['background'] ? 1 : 0,
        'set': data['set'],
        'num': data['num'],
        'active': 0,
        'format_id': this.toFormat['id'],
        'format_width': convertToPixels(this.toFormat['width'], this.toFormat['unit']),
        'format_height': convertToPixels(this.toFormat['height'], this.toFormat['unit']),
        'tag': data['tag']
      };

      INKIVE.Helpers.api('management/layoutinfo', 'POST', { info: info }, function (result) {
        if (result && result.status == 'success') {
          deferred.resolve(_.extend(info, { id: result.id }));
        } else {
          deferred.reject();
        }
      });

      return deferred.promise();
    }

    function resizeContent (newTemplateInfo) {
      var deferred = $.Deferred();

      EditorModeManager.setMode('template', newTemplateInfo);
      DesignFacade.once('template.update.designed', function () {
        deferred.resolve(newTemplateInfo);
      });

      DesignFacade.set('template', {
        keep_stage_size: true,
        designed: { id: template['id'] }
      });

      return deferred.promise();
    }

    function save (newTemplateInfo) {
      var deferred = $.Deferred();

      this.tool.save(null, function () {
        deferred.resolve(template, newTemplateInfo['id']);
      });

      return deferred.promise();
    }
  },

  updateThumbnail: function (oldTemplate, newTemplateId) {
    var deferred = $.Deferred();
    var mismatchTolerance = this.mismatchPerfect;
    var thumbnail = _.find(this.$el.find('ul.thumbnail-wrapper li.thumbnail'), function (thumbnail) {
      return $(thumbnail).data('templateid') == oldTemplate['id'];
    });

    INKIVE.Helpers.api('search/layout', 'GET', { id: newTemplateId }, function (newTemplate) {
      $(thumbnail).find('.to-format img').attr('src', newTemplate['url']);
      oldTemplate.match = newTemplate;

      resemble(oldTemplate['url']).compareTo(newTemplate['url'].replace(/\/\/static\./, '//oregon.'))
        .onComplete(function (data) {
          var isSimilar = parseFloat(data.misMatchPercentage) < mismatchTolerance;
          $(thumbnail).find('.to-format').toggleClass('ok', isSimilar);
          deferred.resolve();
        });
    });

    return deferred.promise();
  },

  loadAllTemplatesByFormat: function (formatId, active) {
    var start = 0;
    var limit = 10;
    var results = [];
    var deferred = $.Deferred();

    loadMore.call(this);

    return deferred.promise();

    function loadMore () {
      var params = {
        from: start,
        limit: limit,
        where: { format: formatId, active: active }
      };

      start += limit;

      this.$el.find('.progress p').text('Loading format ' + formatId + ', page ' + Math.round(start / limit));
      INKIVE.Helpers.api('search/layouts', 'GET', params, _.bind(function (result) {
        if (result && result.data && result.data.length) {
          results = _.union(results, result.data);
          loadMore.call(this);
        } else deferred.resolve(results);
      }, this));
    }
  },

  preloadThumbnails: function (fromTemplates, toTemplates) {
    var deferred = $.Deferred();
    var thumbnails = {};
    var templates = _.union(fromTemplates, toTemplates);
    var total = templates.length;

    loadMore.call(this);

    return deferred.promise();

    function loadMore () {
      var thumbnailsLoadNumber = templates.length > 3 ? 3 : templates.length;
      var afterPartialLoad = _.after(thumbnailsLoadNumber, _.bind(loadMore, this));
      var percent = Math.round(((total - templates.length) / total) * 100);

      this.$el.find('.progress p').text('Loading thumbnails ' + percent + '%');
      templates.length || deferred.resolve(fromTemplates, toTemplates, thumbnails);

      while (thumbnailsLoadNumber-- > 0 && templates.length) {
        var template = templates.pop();

        if (template['url']) {
          var image = new Image();
          image.setAttribute('crossOrigin', 'anonymous');
          image.src = INKIVE.Helpers.getCORSSecureUrl(template['url']);
          image.onerror = afterPartialLoad;
          image.onload = function () {
            _.defer(afterPartialLoad);
            var canvas = document.createElement('canvas');
            canvas.width = this.naturalWidth;
            canvas.height = this.naturalHeight;

            canvas.getContext('2d').drawImage(this, 0, 0);
            this.rawData = canvas.toDataURL('image/png');
          };

          thumbnails[template['id']] = image;
        } else afterPartialLoad();
      }
    }
  },

  compare: function (fromTemplates, toTemplates, thumbnails) {
    var fromCopy = _.filter(fromTemplates, isValidTemplate);
    var toCopy = _.filter(toTemplates, isValidTemplate);
    var deferred = $.Deferred();
    var compareTemplate = _.bind(compareTemplate, this);
    var total = fromCopy.length;
    var misMatchPercentages = [];
    var mismatchSame = this.mismatchSame;
    var mismatchPerfect = this.mismatchPerfect;

    compareTemplate();

    return deferred.promise();

    function isValidTemplate (template) {
      return thumbnails[template['id']]; // template && template['url'];
    }

    function compareTemplate () {
      if (!fromCopy.length) {
        this.templates = _.filter(fromTemplates, isValidTemplate);
        matchTemplates();
        return;
      }

      var closest;
      var closestMisMatch = 100;
      var fromId = fromCopy.pop()['id'];
      var afterCompare = _.after(toCopy.length, _.bind(compareTemplate, this));

      var percent = Math.round(((total - fromCopy.length) / total) * 100);
      this.$el.find('.progress p').text('Matching templates ' + percent + '%');

      toCopy.length || compareTemplate.call(this);
      _.each(toCopy, function (toTemplate) {
        var toId = toTemplate['id'];
        var fromData = thumbnails[fromId].rawData;
        var toData = thumbnails[toId].rawData;

        if (!fromData || !toData) {
          _.defer(afterCompare);
          return;
        }

        resemble(fromData).compareTo(toData).onComplete(function (data) {
          var misMatch = parseFloat(data.misMatchPercentage);
          misMatch < mismatchSame && misMatchPercentages.push({
            fromId: fromId,
            toId: toId,
            misMatch: misMatch
          });

          _.defer(afterCompare);
        });
      });

      function matchTemplates () {
        var matchedTo = [];
        var matchedFrom = [];

        _.each(_.sortBy(misMatchPercentages, 'misMatch'), function (obj) {
          var isPendent = !_.contains(matchedTo, obj.toId)
            && !_.contains(matchedFrom, obj.fromId);

          if (isPendent) {
            var template = _.find(fromTemplates, { id: obj.fromId });
            template['match'] = _.find(toTemplates, { id: obj.toId });
            template['hasPerfectMatch'] = obj.misMatch < mismatchPerfect;
            matchedTo.push(obj.toId);
            matchedFrom.push(obj.fromId);
          }
        });

        deferred.resolve();
      }
    }
  },

  renderThumbnails: function () {
    _.each(this.templates, function (data) {
      if (data['url']) {
        this.$el.find('ul.thumbnail-wrapper')
          .append($('<li class="thumbnail"></li>')
            .html(this.getThumbnailHTML(data))
            .data('templateid', data['id'])
          );
      }
    }, this);

    this.initScroll();
  },

  getThumbnailHTML: function (template) {
    var angle = (Math.PI / 2 - Math.atan(this.fromFormat['height'] / this.fromFormat['width'])) / (Math.PI / 180);
    var params = _.extend(extractData(template), { angle: angle });
    if (template['match']) params['match'] = extractData(template['match']);

    return thumbnailTemplate(params);

    function extractData (item) {
      return {
        url: item['url'],
        has_perfect_match: item['hasPerfectMatch'],
        thumb_height: 255 * (item['format_height'] / item['format_width'])
      };
    }
  },

  initialize: function () {
    _.bindAll(this,
      'render',
      'compare',
      'updateThumbnail',
      'renderThumbnails',
      'preloadThumbnails',
      'loadAllTemplatesByFormat'
    );

    FormatFactory.getGroups().then(this.render);
    this.tool = INKIVE.Tool.getInstance();
  },

  render: function (groups) {
    this.$el.html(template({
      groups: groups
    }));
  }
}), ScrollableMixin);
